var _path, _g, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGnosisSafe = function SvgGnosisSafe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2721_64477)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2721_64477",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2721_64477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.064 -2.60797H-1.53601V34.288H32.064V-2.60797Z",
    fill: "url(#paint0_linear_2721_64477)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9623 15.994H22.7763C22.1235 15.994 21.5946 16.5233 21.5946 17.1757V20.3482C21.5946 21.001 21.0653 21.53 20.4128 21.53H11.7162C11.0634 21.53 10.5344 22.0593 10.5344 22.7117V24.8977C10.5344 25.5505 11.0637 26.0794 11.7162 26.0794H20.9162C21.569 26.0794 22.0909 25.5501 22.0909 24.8977V23.1441C22.0909 22.4913 22.6202 22.0279 23.2727 22.0279H24.9623C25.6151 22.0279 26.144 21.4986 26.144 20.8461V17.1617C26.144 16.5089 25.6147 15.9937 24.9623 15.9937V15.994Z",
    fill: "#121312"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5338 11.6515C10.5338 10.9987 11.0631 10.4698 11.7156 10.4698H20.4068C21.0596 10.4698 21.5885 9.94051 21.5885 9.28803V7.10211C21.5885 6.44931 21.0593 5.92035 20.4068 5.92035H11.2119C10.5591 5.92035 10.0301 6.44963 10.0301 7.10211V8.78627C10.0301 9.43907 9.50086 9.96803 8.84838 9.96803H7.16614C6.51334 9.96803 5.98438 10.4973 5.98438 11.1498V14.8381C5.98438 15.4909 6.51558 15.9933 7.16838 15.9933H9.3543C10.0071 15.9933 10.5361 15.464 10.5361 14.8115L10.5341 11.6519L10.5338 11.6515Z",
    fill: "#121312"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0352 13.6964H17.1351C17.8192 13.6964 18.3747 14.2519 18.3747 14.936V17.0359C18.3747 17.72 17.8192 18.2755 17.1351 18.2755H15.0352C14.3511 18.2755 13.7955 17.72 13.7955 17.0359V14.936C13.7955 14.2519 14.3511 13.6964 15.0352 13.6964Z",
    fill: "#121312"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2721_64477",
    x1: -0.47809,
    y1: 29.2685,
    x2: 37.0896,
    y2: -2.77789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12FF80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#15FD85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#1FF896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#30F1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#48E7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#5FDDFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2721_64477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};

export { SvgGnosisSafe as ReactComponent };
export default __webpack_public_path__ + "25f28f335b5d68136c6b271622e17cd9.svg";